import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import conciergeApiClient from "Services/Apis/Concierge/conciergeApiClient";

export const getConvertedPointsThunk = createAsyncThunk(
  "GetConvertedPoints/getConvertedPointsThunk",
  async (points, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile["custom:campaign_id"],
      catalogId: user.profile["custom:catalog_id"],
      participantId: user.profile["custom:participant_id"],
      username: user.profile.username || user.profile["custom:login"],
    };

    const config = {
      headers,
      params: { points },
    };

    const { data } = await conciergeApiClient.get(
      "Product/get-converted-points",
      config
    );

    return data;
  }
);

const initialState = {
  convertedPoints: undefined,
  isConvertedPointsLoading: false,
  convertedPointsHasErrors: false,
};

const GetConvertedPointsSlice = createSlice({
  name: "GetConvertedPoints",
  initialState,
  reducers: {
    resetConvertedPointsData: (state) => {
      state.convertedPoints = undefined;
      state.isConvertedPointsLoading = false;
      state.convertedPointsHasErrors = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConvertedPointsThunk.pending, (state) => {
      state.convertedPoints = undefined;
      state.isConvertedPointsLoading = true;
      state.convertedPointsHasErrors = false;
    });

    builder.addCase(getConvertedPointsThunk.fulfilled, (state, action) => {
      state.convertedPoints = action.payload;
      state.isConvertedPointsLoading = false;
      state.convertedPointsHasErrors = false;
    });

    builder.addCase(getConvertedPointsThunk.rejected, (state) => {
      state.convertedPoints = undefined;
      state.isConvertedPointsLoading = false;
      state.convertedPointsHasErrors = true;
    });
  },
});

export const { resetConvertedPointsData } = GetConvertedPointsSlice.actions;
export default GetConvertedPointsSlice.reducer;
